import React from "react";
import { Route, Switch } from "react-router-dom";
import "./styles.scss";
import { Container, Row, Col } from "react-bootstrap";
import SubMenu from "../../../components/side-nav-bar/sub-menus";
import SubMenuAccount from "../../../components/side-nav-bar/sub-menus/containers/account/containers/SubMenuAccount";
import UserProfileComponent from "../components/user-profile/UserProfileComponent";
import MemberProfile from "./index-member.profile";
import TeamProfile from "./index-team-profile";
import UserProfileEditComponent from "../components/user-profile/UserProfileEditComponent";
import CreateAccount from "./create-account/CreateAccount";
import TeamProfileEditComponent from "../../teams/containers/edit-team/TeamProfileEditComponent";

export enum DashboardAccountsPages {
  ACCOUNT = "/dashboard/account",
  ACCOUNT_COMPANY = "/dashboard/account/company/:id",
  CREATE_ADMIN_ACCOUNT = "/dashboard/account/admin/create",
  CREATE_MODERATOR_ACCOUNT = "/dashboard/account/modarator/create",
  CREATE_MEMBER_ACCOUNT = "/dashboard/account/member/create",
  ACCOUNT_EDIT = "/dashboard/account/edit",
  MEMBER_PROFILE_ACCOUNT = "/dashboard/account/members/:id",
  TEAM_PROFILE_ACCOUNT = "/dashboard/account/teams/:id",
}

const Account = () => {
  return (
    <div className="dashboard-account-wrapper">
      <SubMenu>
        <SubMenuAccount />
      </SubMenu>
      <Container fluid className="account-wrapper pt-0">
        <Row>
          <Col md={12} lg={12} sm={12}>
            <Switch>
              <Route exact path={DashboardAccountsPages.ACCOUNT}>
                <UserProfileComponent />
              </Route>
              <Route exact path={DashboardAccountsPages.ACCOUNT_COMPANY}>
                <TeamProfileEditComponent />
              </Route>
              <Route path={DashboardAccountsPages.ACCOUNT_EDIT} exact>
                <UserProfileEditComponent />
              </Route>
              <Route path={DashboardAccountsPages.MEMBER_PROFILE_ACCOUNT}>
                <MemberProfile />
              </Route>
              <Route path={DashboardAccountsPages.TEAM_PROFILE_ACCOUNT}>
                <TeamProfile />
              </Route>
              <Route path={DashboardAccountsPages.CREATE_ADMIN_ACCOUNT}>
                <CreateAccount
                  userRole={{
                    isAdmin: true,
                    isModerator: true,
                    isMember: true,
                  }}
                />
              </Route>
              <Route path={DashboardAccountsPages.CREATE_MODERATOR_ACCOUNT}>
                <CreateAccount
                  userRole={{
                    isAdmin: false,
                    isModerator: true,
                    isMember: true,
                  }}
                />
              </Route>
              <Route path={DashboardAccountsPages.CREATE_MEMBER_ACCOUNT}>
                <CreateAccount
                  userRole={{
                    isAdmin: false,
                    isModerator: false,
                    isMember: true,
                  }}
                />
              </Route>
            </Switch>
          </Col>
          <Col md={3} lg={2} style={{ borderLeft: "solid 1px #333" }} />
        </Row>
      </Container>
    </div>
  );
};

export default Account;
